import React from 'react'
import Menu from 'react-burger-menu/lib/menus/slide'
import HeaderNav from './header-nav'

export default class MenuComponent extends React.Component {
  constructor() {
    super()
  }
  tellMe() {
    alert('me')
    }
  showSettings(event) {
    event.preventDefault();
  }



  render() {
    return (
      <Menu isOpen={ false } pageWrapId={"page-wrap"} outerContainerId={"outer-container"}>
        <HeaderNav class="burger-nav" onClick={this.tellMe} />
        {/* <a id="home" className="menu-item" href="/">Home</a>
        <a id="about" className="menu-item" href="/about">About</a>
        <a id="contact" className="menu-item" href="/contact">Contact</a>
        <a onClick={this.showSettings} className="menu-item--small" href="">Settings</a> */}
      </Menu>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/burger-menu.js